import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('sanity'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  avatarPath: avatars.sanity,
  logoPath: logos.sanity
});
